import { render, staticRenderFns } from "./OutsideMannersClasses.vue?vue&type=template&id=181e1a8b&scoped=true&"
import script from "./OutsideMannersClasses.vue?vue&type=script&lang=js&"
export * from "./OutsideMannersClasses.vue?vue&type=script&lang=js&"
import style0 from "./OutsideMannersClasses.vue?vue&type=style&index=0&id=181e1a8b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181e1a8b",
  null
  
)

export default component.exports